import Vue from 'vue'
import Router from 'vue-router'

import Payment from '@/views/Payment.vue'
import Landing from '@/views/Landing.vue'
import ConfirmEmail from '@/views/ConfirmEmail.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'landing',
      path: '/',
      component: Landing
    },
    {
      name: 'protect',
      path: '/protect',
      component: () => import(/* webpackChunkName: "protect" */ '@/views/ProtectWizard/Wizard.vue')
    },
    {
      name: 'payment',
      path: '/payment',
      component: Payment,
      props: true
    },
    {
      name: 'confirm-email',
      path: '/confirm-email',
      component: ConfirmEmail
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
